import type { ParameterizedConceptDTO } from "@eu.mdotm.api/smart-workspaces";
import type { WorkspaceChain } from "./chain/type";
import type { PersistedConceptFields } from "./spec-gaps";

/**
 * A chain's answers as the concept they describe — the one chain → concept translation in the area.
 *
 * It lived in `controllers/shared.ts` and moved out with the controllers: nothing about it is
 * controller-specific, and a second copy of it is exactly the bug family this MR exists to close — there
 * were six of these, and two of them disagreed. `PersistedConceptFields` is the guard that keeps
 * request-time flags — `timeSeries`, `breakdown` — out of what gets stored.
 */
export function workspaceChainToConceptDto(chain: WorkspaceChain): Omit<ParameterizedConceptDTO, "uuid"> {
	return {
		conceptId: chain.concept!.id!,
		label: chain.name!,
		timeHorizon: chain.timeHorizon,
		representationMode: chain.representationMode,
		relativeness: chain.parameterizedRelativeness,
		source: chain.source ?? "CURRENT",
		confidenceLevel: chain.confidenceLevel,
		parameters: chain.parameters as any,
	} satisfies PersistedConceptFields;
}
